export default __webpack_public_path__ + "static/media/Crocodile.75f4792e.jpg";